// @flow

// Effect Managers
import { call } from 'redux-saga/effects'

// Constants
import {
  DELETE,
} from '../constants'

// Types
import type {
  GetFetchOptionsReturn,
  ComposeDeleteArgs,
  DeleteArgs,
  DeleteResponse,
  Delete,
} from '../../types'

// Exports
export default function ({
  getFetchOptions,
  getUrl,
  }: ComposeDeleteArgs): Delete {
  return function *__get ({ path, id, token, excludeToken }: DeleteArgs): Generator<*, DeleteResponse, *> {
    const options: GetFetchOptionsReturn = yield call(getFetchOptions, {
      type: DELETE,
      token,
    })

    const url: string = getUrl({path, id})
    const response: Response = yield call(fetch, url, options)

    return response
  }
}
